import { SiteFiltersStore } from "../store";
import { sanitiseVueObservable } from "../../../helpers/sanitiseVueObservable";
import { useSnapshot } from "valtio";

export const useLocalAuthorities = (store: SiteFiltersStore) => {
  const { localAuthorities } = useSnapshot(store);

  return sanitiseVueObservable(localAuthorities) as string[];
};
